export default __webpack_public_path__ + "static/how_2-2f8711e7796c219ef558e427038bc0d1.png";